// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, string } from 'prop-types'
import { reduxForm, Field } from 'redux-form'
import { FormWrapper } from './styles'
import validate from './validate'

import {
  SubmitErrors,
  UpdatedLabeledInput,
} from 'components/Form'

const Form = props => {
  const {
    error,
    form,
    handleSubmit,
    initialize,
  } = props

  const clearForm = () => initialize({
    contactCode: '',
    jobCode: '',
    rcnNumber: '',
  })

  return (
    <form className={'bg-blue-dark database-search-wrapper'}>
      <SubmitErrors
        error={error}
        idRoot={form}
        sourceForm={form} />
      <FormWrapper>
        <Field
          autoFocus={true}
          className={'rcn'}
          component={UpdatedLabeledInput}
          id={`${form}-rcn`}
          label={'RCN'}
          name={'rcnNumber'} />
        <Field
          className={'job-number'}
          component={UpdatedLabeledInput}
          id={`${form}-job-number`}
          label={'Job Number'}
          name={'jobCode'} />
        <Field
          className={'contact-code'}
          component={UpdatedLabeledInput}
          id={`${form}-contact-code`}
          label={'Contact Code'}
          name={'serviceContactCode'} />
        <button
          className={'submit btn search-button big-button heading-font'}
          id={`${form}-submit`}
          onClick={handleSubmit}
          type={'submit'}>
          {'Search'}
        </button>
        <p
          className={`clear btn search-button big-button bg-pink text-white display-block heading-font`}
          id={`${form}-clear`}
          onClick={clearForm}>
          {'Clear'}
        </p>
      </FormWrapper>
    </form>
  )
}

Form.propTypes = {
  error: string,
  form: string.isRequired,
  handleSubmit: func.isRequired,
  initialize: func.isRequired,
}

export default reduxForm({
  validate,
})(Form)
